import lazyLoading from '../global/lazyLoading';
import header from '../global/header';
import ocm from '../global/ocm.js';
import caseStudyFilter from '../global/caseStudyFilter.js';
import caseStudyCarousel from '../global/caseStudyCarousel.js';
import awardsCarousel from '../global/awardsCarousel.js';
import teamsCarousel from "../global/teamsCarousel";
import frontpageHero from '../global/frontpageHero.js';
import valuesSlider from "../global/valuesSlider";
import insightsArchive from "../global/insightsArchive";
import insightsCarousel from "../global/insightsCarousel";
import infiniteScroll from "../util/InfiniteScroll";

export default {
	init() {
		lazyLoading.init();
        header.init();
        ocm.init();
        caseStudyFilter.init();
        caseStudyCarousel.init();
        awardsCarousel.init();
        teamsCarousel.init();
        frontpageHero.init();
        valuesSlider.init();
        insightsArchive.init();
        insightsCarousel.init();
        infiniteScroll.init();
	},
	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	}
};
